<template>
  <b-table
    class="is-middle"
    :loading="collections.loading"
    :data="collections.data"
    :current-page="collections.current_page"
    :per-page="collections.per_page"
    :total="collections.total"
    @page-change="
          page => {
            collections.changePage(page);
          }
        "
    backend-sorting
    @sort="(field, direction) => collections.sort(field, direction)"
    paginated
    backend-pagination
    pagination-position="bottom"
  >
    <template slot-scope="props">
      <b-table-column label="#" sortable field="id">{{ props.row.id }}</b-table-column>

      <b-table-column :label="$tc('name')" sortable field="name">
        <router-link :to="'/collections/' + props.row.id + '/edit'">{{ props.row.name }}</router-link>
      </b-table-column>

      <!--          <b-table-column label="Түлхүүр">-->
      <!--            <span class="has-text-grey">{{ props.row.slug }}</span>-->
      <!--          </b-table-column>-->

      <b-table-column :label="$tc('support_ticket.title')">
        <span class="has-text-grey">{{ props.row.title }}</span>
      </b-table-column>

      <b-table-column :label="$tc('support_ticket.title')+'(MN)'">
        <span class="has-text-grey">{{ props.row.mn_title }}</span>
      </b-table-column>

      <b-table-column :label="$tc('support_ticket.auto')" centered>
        <b-icon
          v-if="props.row.has_collector && props.row.has_active_collector"
          icon="check"
          type="is-success"
        ></b-icon>
      </b-table-column>

      <b-table-column :label="$tc('issues')" centered>
            <span class="has-text-grey">
              {{ props.row.issues_count }}
            </span>
      </b-table-column>

      <b-table-column :label="$tc('magazines.categories')" centered>
            <span class="has-text-grey">
              {{ props.row.type }}
            </span>
      </b-table-column>

      <b-table-column :label="$tc('dater.created')" centered sortable field="created_at">
        <span class="has-text-grey">{{ props.row.created_at | dateTime }}</span>
      </b-table-column>
      <b-table-column custom-key="actions">
        <div class="is-pulled-right">
          <links-dropdown
            :links="[
                    {
                      label: 'Deep Link',
                      url: `${dl}://q?type=collection&slug=${props.row.slug}`,
                    },
                  ]"
          ></links-dropdown>
        </div>
      </b-table-column>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    event:{
      type:Boolean
    }
  },

  data() {
    return {
      dl: this.$store.state.config.app.dl,
      collections: new window.PaginatedRemoteCollection(
        "/admin/api/collections?type=magazine"
      ).load()
    };
  },

  methods: {
    reload() {
      this.collections.load();
    }
  }
};
</script>
